export default `float s=2., e=0.;
    for(int i=0;i++<8;p=abs(p)*e)
      p=vec3(.8,2.0,1.0)-abs(p-vec3(1.0,2.0,1.0)),
      s*=e=1.3/clamp(dot(p,p),.1,1.2);
    return min(length(p.xz),p.y)/s+.001;
  }`